<template>
  <v-container
    fluid
    fill-height
    class="grey lighten-4"
  >
    <v-row
      justify="center"
      align="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        lg="4"
      >
        <v-card
          v-if="!resetLinkSent"
          elevation="10"
          class="py-8"
        >
          <v-row justify="center">
            <v-col
              cols="10"
              sm="8"
              class="text-center"
            >
              <v-img
                src="/img/quats-logo.png"
              />
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              cols="11"
              class="text-center"
            >
              <h2>{{ $t('login.password_reset') }}</h2>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              cols="11"
              class="text-center"
            >
              <p style="font-size: 14px;">
                {{ $t('login.password_reset_instruction_1') }}
              </p>
              <p style="font-size: 14px;">
                {{ $t('login.password_reset_instruction_2') }}
              </p>
            </v-col>
          </v-row>
          <v-form
            ref="resetForm"
            lazy-validation
          >
            <v-row justify="center">
              <v-col
                cols="11"
                sm="9"
              >
                <v-text-field
                  v-model="loginId"
                  dense
                  :placeholder="$t('login.quats_id')"
                  outlined
                  hide-details="auto"
                  :rules="loginIdRules"
                  @keydown.enter="submit"
                />
              </v-col>
            </v-row>
          </v-form>
          <v-row
            v-if="errorState"
            justify="center"
          >
            <v-col
              cols="11"
              sm="9"
            >
              <v-alert
                v-if="errorState"
                dense
                type="error"
                close-icon="mdi-close-circle-outline"
                :dismissible="true"
              >
                {{ error }}
              </v-alert>
            </v-col>
          </v-row>
          <v-row
            justify="center"
            class="mt-4"
          >
            <v-col
              cols="11"
              sm="6"
              class="text-center"
            >
              <v-btn
                :loading="loading"
                block
                style="color: white;"
                color="primary"
                @click="submit"
              >
                {{ $t('login.reset') }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              cols="11"
              sm="6"
              class="text-center"
            >
              <v-btn
                block
                outlined
                small
                :to="'/login'"
              >
                <v-icon class="mr-2">
                  mdi-arrow-left
                </v-icon>
                {{ $t('login.back_to_login') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
        <v-card
          v-else
          class="py-8"
        >
          <v-row justify="center">
            <v-col
              cols="10"
              sm="8"
              class="text-center"
            >
              <v-img
                src="/img/quats-logo.png"
              />
            </v-col>
          </v-row>
          <v-row
            justify="center"
          >
            <v-col
              cols="11"
              class="text-center"
            >
              <h2>{{ $t('login.reset_link_sent') }}</h2>
            </v-col>
            <v-col
              cols="11"
              class="text-center"
            >
              <v-icon x-large>
                mdi-email-check
              </v-icon>
            </v-col>
            <v-col cols="11">
              <p
                style="font-size: 14px"
                class="text-center"
              >
                {{ $t('login.reset_info') }}
              </p>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col
              cols="11"
              sm="6"
              class="text-center"
            >
              <v-btn
                block
                outlined
                small
                :to="'/login'"
              >
                <v-icon class="mr-2">
                  mdi-arrow-left
                </v-icon>
                {{ $t('login.back_to_login') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>

export default {
  data () {
    return {
      resetLinkSent: false,
      loginId: null,
      loading: false,
      error: null,
      errorState: false
    }
  },
  computed: {
    loginIdRules () {
      return [
        v => !!v || this.$t('login.quats_id_required'),
        v => {
          const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          const numberPattern = /^[0-9]*$/
          if (emailPattern.test(v)) {
            return true
          } else if (numberPattern.test(v)) {
            return true
          }
          return this.$t('login.quats_id_invalid')
        }
      ]
    }
  },
  methods: {
    submit (e) {
      e.preventDefault()
      if(this.$refs.resetForm.validate()) {
        this.loading = true
        const postData = { login_id: this.loginId }
        return window.axios.head('/sanctum/csrf-cookie')
          .then(()=> {
            return window.axios.post('/api/auth/forgot-password', postData)
              .then(() => {
                this.loading = false
                this.resetLinkSent = true
                this.errorState = false
              }).catch(err => {
                if (err.response?.status === 404) {
                  this.error = new Error(this.$t('error_message.not_found'))
                } else {
                  this.error = new Error(this.$t('error_message.something_went_wrong'))
                }
                this.loading = false
                this.errorState = true
              })
          }).catch(err => {
            this.error = err.response.data.message
            this.loading = false
            this.errorState = true
          })
      }
    }
  }
}
</script>
